import React, { useState, useEffect } from 'react'
import AccountBody from './AccountBody';
import { PDFExport } from '@progress/kendo-react-pdf';

const AccountTable = React.forwardRef(({ data, searchTerm }, ref) => {
    const [filterResult, setFilterResult] = useState([]);

    useEffect(() => {
        const filtered = data.filter(data => data.member && data.member.toLowerCase().includes(searchTerm.toLowerCase()) || data.pkg && data.pkg.toLowerCase().includes(searchTerm.toLowerCase()) || data.invoice && data.invoice.toLowerCase().includes(searchTerm.toLowerCase()) || data.rNo && data.rNo.toLowerCase().includes(searchTerm.toLowerCase()) || data.cAmt && data.cAmt.toString().toLowerCase().includes(searchTerm.toLowerCase()) || data.rAmt && data.rAmt.toString().toLowerCase().includes(searchTerm.toLowerCase()) || data.remarks && data.remarks.toLowerCase().includes(searchTerm.toLowerCase()));

        setFilterResult(filtered);
    }, [searchTerm, data])


    return (
        <div className="flex flex-col">
            <div className="overflow-x-auto mx-2">
                <div className=" pt-8 lg:py-2 inline-block min-w-full px-2 sm:px-4 lg:px-6">
                    <div className="overflow-hidden">
                        <PDFExport paperSize="A4" fileName="dashboard" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                            <table className="min-w-full border text-center" id='table-to-xls'>
                                <thead className="border-b">
                                    <tr>
                                        <th scope="col" className="table_head">
                                            Sno
                                        </th>
                                        <th scope="col" className="table_head">
                                            Member
                                        </th>
                                        <th scope="col" className="table_head">
                                            Package
                                        </th>
                                        <th scope="col" className="table_head">
                                            Charge Date
                                        </th>
                                        <th scope="col" className="table_head">
                                            Charge Amount
                                        </th>
                                        <th scope="col" className="table_head">
                                            Receipt Amount
                                        </th>
                                        <th scope="col" className="table_head">
                                            Balance Amount
                                        </th>
                                        <th scope="col" className="table_head">
                                            Receipt Date
                                        </th>
                                        <th scope="col" className="table_head">
                                            Invoice No.
                                        </th>
                                        <th scope="col" className="table_head">
                                            Receipt No.
                                        </th>
                                        <th scope="col" className="table_head">
                                            Remarks
                                        </th>
                                    </tr>
                                </thead>
                                {filterResult.length > 0 ? (filterResult.map((item, index) => <AccountBody key={index} item={item} />)) : <tbody><tr><td colSpan="100%" className='py-3 text-sm text-gray-800'>No Data Are Available</td></tr></tbody>}
                            </table>
                        </PDFExport>
                    </div>
                </div>
            </div>
        </div>
    )
});

export default AccountTable;